import environment from '@/modules/cart/environments/environment';
import type { HttpCartDto } from '@/modules/cart/infrastructure/dto/HttpCartRepositoryDto';
import httpClient from '@/modules/cart/services/api/client';
import type { HttpShippingMethodDraft } from '@/modules/shippingMethod/infrastructure/dto/HttpShippingMethodDto';

const { CART_URL } = environment;

const SHIPPING_METHOD_URL = `${CART_URL}/shipping-methods`;

export async function selectShippingMethod(
  shippingMethod: HttpShippingMethodDraft[]
): Promise<{ data: HttpCartDto }> {
  const expandParam =
    'lineItems[*].variant.attributes[*].value&expand=discountCodes[*].discountCode';
  const url = `${SHIPPING_METHOD_URL}?expand=${expandParam}`;
  return httpClient.post(url, shippingMethod);
}
